import { DataType } from '@wix/editor-platform-ooi-metadata-resolver';
import {
  createSettingsParams,
  type ISettingsParam,
  type PartialBy,
} from '@wix/tpa-settings';
import { LayoutOptions } from '../../types/types';
import {
  booleanSettingsParam,
  enumSettingsParam,
  settingsParamWithMobileDefault,
  type ISettingsParams,
} from '../BookingCalendar/settingsParams';
import timetableSettingsParams from '../WeeklyTimetable/settingsParams';

type DailyAgendaSettingsOverride = Pick<
  ISettingsParams,
  'calendarLayout' | 'maxTimeSlotsDisplayedPerDay' | 'limitTimeSlotsDisplay'
>;

type IDailyAgendaSettingsParamsDefinitions = {
  [key in keyof DailyAgendaSettingsOverride]: PartialBy<
    ISettingsParam<DailyAgendaSettingsOverride[key]>,
    'key'
  >;
};

export const dailyAgendaSettingsParamsDefinitions: IDailyAgendaSettingsParamsDefinitions =
  {
    calendarLayout: enumSettingsParam(LayoutOptions.DAILY_AGENDA_WEEKLY_PICKER),
    maxTimeSlotsDisplayedPerDay: settingsParamWithMobileDefault(
      DataType.number,
      6,
      1,
    ),
    limitTimeSlotsDisplay: booleanSettingsParam(true),
  };

const dailyAgendaSettingsParams =
  createSettingsParams<DailyAgendaSettingsOverride>(
    dailyAgendaSettingsParamsDefinitions,
  );

export default {
  ...timetableSettingsParams,
  ...dailyAgendaSettingsParams,
};
